// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";

const envanteriumDarkLogo = require("../../Assets/Logo/envanterium-logo-text-only-dark.png");

type PropsType = {
  translate: string => void,
  setActiveLanguage: string => void
};

type StateType = {};

class Footer extends Component<PropsType, StateType> {
  render() {
    const { translate } = this.props;

    return (
      <footer className="footer bg-gray py-9">
        <div className="container">
          <div className="row gap-y">
            <div className="col-md-6 col-xl-4">
              <p>
                <Link to="/">
                  <img className="envanterium-navbar-logo" src={envanteriumDarkLogo} alt="envanterium-darklogo" />
                </Link>
              </p>
              <p>{translate("FooterLocale.description_panel.content")}</p>
            </div>

            <div className="col-6 col-md-3 col-xl-2">
              <h6 className="mb-4 mt-1">
                <strong>{translate("FooterLocale.company.title")}</strong>
              </h6>
              <div className="nav flex-column">
                <Link to="/hakkimizda" className="nav-link">
                  {translate("FooterLocale.company.about")}
                </Link>
                <Link to="/iletisim" className="nav-link">
                  {translate("FooterLocale.company.contact")}
                </Link>
              </div>
            </div>

            <div className="col-6 col-md-3 col-xl-3">
              <h6 className="mb-4 mt-1">
                <strong>{translate("FooterLocale.product.title")}</strong>
              </h6>
              <div className="nav flex-column">
                <Link to="/envanter-sayim" className="nav-link">
                  {translate("FooterLocale.product.processing")}
                </Link>
                <Link to="/ik-cozumleri" className="nav-link">
                  {translate("FooterLocale.product.hrsolutions")}
                </Link>
              </div>
            </div>

            <div className="col-6 col-md-6 col-xl-3 text-center">
              <p>
                <Link to="/kayit-ol" className="btn btn-block btn-round btn-primary">
                  {translate("FooterLocale.action_panel.action")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js